<script>
  import { creators } from '../../utils/common';

  export let creator = 'all';
  export let refreshCallback = () => {};
</script>

<span class="date-label">Game</span>
<select class="form-select" bind:value={creator} on:change={refreshCallback}>
  <option value="all">All</option>
  {#each Object.entries(creators) as [key, val]}
    <option value="{key}">{val}</option>
  {/each}
</select>